import { Component, OnInit, OnDestroy, PipeTransform, Pipe } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { EnrolToModuleService } from 'app/enrol-to-module/enrol-to-module.service';
import { AuthService } from '../shared/auth/auth.service';

@Component({
  selector: 'auto-enrol',
  templateUrl: './auto-enrol.component.html'
})
export class AutoEnrolComponent implements OnInit, OnDestroy {
  test = "";
  iBreezeUserID: string;
  breezeSessionString: string;
  selectedValue: string;
  enrolProcess: boolean;
  constructor(public _authService: AuthService, private _route: ActivatedRoute,
    private _router: Router, private enrolToModuleService: EnrolToModuleService) {
  }

  ngOnInit() {
    this._route.params.subscribe(params => {


      let iModuleID = params['scoID'];
      this.breezeSessionString = this._authService.getBreezeSessionString();
      this.iBreezeUserID = this._authService.getUserData().iBreezeUserID;

      this.test = iModuleID + " - " + this.breezeSessionString;
      this.enrolToModule(iModuleID);

    });


  }

  ngOnDestroy() {
    // this.paramSub.unsubscribe();
  }
  enrolToModule(iModuleID) {

    this.enrolToModuleService.enrolUser(this.iBreezeUserID, iModuleID, this.breezeSessionString, "23", "1", "4").subscribe(
      enrolResponse => {

        if (enrolResponse) {
          //this.enrolProcess = true;
          this.enrolToModuleService.getModuleByModuleId("enrol", iModuleID).subscribe(
            moduleToEnrol => {
              let module:any=moduleToEnrol;
              window.location.href=module.vurl+'?session='+this.breezeSessionString;
            },
            err => {
              console.log(err);
            });
       
          
        } else {
          // this.enrolProcess = false;
          alert("Enrol false");
        }
      },
      err => {
        console.log(err);
      });

  }


}





// WEBPACK FOOTER //
// ./src/app/auto_enrol/auto-enrol.component.ts